export default __webpack_public_path__ + "static/blob11-94ad13455354c62980cce8127c62cd4d.svg";